import angular from 'angular';

import '../../../core/main/directive/feature_flag/directive'
import './style.scss';

document.write(require('./view.html').default);

angular.module("merchant.application.page.inStore.barcode", [
    "merchant.application.module.device.activateDevice",
    "merchant.application.module.device.redeemBarcode",
    "merchant.application.module.device.posDeviceRequired"
]).controller("merchant.application.page.inStore.barcode.controller", [
    "$rootScope", "$scope", "$controller",
    "merchant.application.main.factory.standalonePosDevice",
    "core.application.main.factory.feature",
    function ($rootScope, $scope, $controller, StandalonePosDevice, Feature) {
        $controller("merchant.application.page.inStore.controller", {$scope: $scope});

        $scope.model.flags = { posWithoutSecrets: false };

        $scope.loadFlags = function() {
            Feature.retrieveFeatureFlagPromise("standalone-pos-without-secrets", false)
                .then(function (flag) {
                    $scope.model.flags.posWithoutSecrets = flag;
                    $scope.$digest();
                });
        };

        $rootScope.$on("featureFlagsReady", $scope.loadFlags);
        $scope.loadFlags();

        $scope.hasDevice = StandalonePosDevice.hasDevice;
    }
]);
